import React from 'react'
import '../../stylings/admissionNotice.css'

const AdmissionNotice = () => {
  return (
    <div className="admission-notice notice-header">
      <p>
        <i className="fa-solid fa-bullhorn pulse-icon"></i>
        ADMISSION OPEN FOR THE SESSION 2026-2027. For more details contact at
        <span>vjconvent2004@gmail.com</span>
      </p>
    </div>
  )
}

export default AdmissionNotice
